import { createAction, handleActions } from 'redux-actions';

const showCatalogPicker = createAction("SCREENS/ORDER_VIEW/SHOW_CATALOG_PICKER");
const hideCatalogPicker = createAction("SCREENS/ORDER_VIEW/HIDE_CATALOG_PICKER");

const defaultState = false;

const reducer = handleActions(
  {
    [showCatalogPicker]: () => true,
    [hideCatalogPicker]: () => false,
    'RESET_ORDER_VIEW': () => defaultState,
  },
  defaultState
);

export { showCatalogPicker, hideCatalogPicker, reducer };
